import { createContext, useContext } from 'react';

const RouterContext = createContext(null);

/** @deprecated Use React-Router hooks directly, this hook only wraps them. */
const useRouter = () => {
  const router = useContext(RouterContext);
  return router;
};

export { RouterContext, useRouter };
